/** Helpers pro globální filtr (kvartál, rok, vlastní rozsah). */
import dayjs from "dayjs";

export interface DateRange {
  from: string; // YYYY-MM-DD
  to: string;
}

export type Quarter = 1 | 2 | 3 | 4;

export function quarterRange(year: number, q: Quarter): DateRange {
  const startMonth = (q - 1) * 3;
  const start = dayjs().year(year).month(startMonth).startOf("month");
  const end = start.add(2, "month").endOf("month");
  return { from: start.format("YYYY-MM-DD"), to: end.format("YYYY-MM-DD") };
}

export function yearRange(year: number): DateRange {
  return {
    from: `${year}-01-01`,
    to: `${year}-12-31`,
  };
}

export function detectQuarter(d: dayjs.Dayjs): Quarter {
  return (Math.floor(d.month() / 3) + 1) as Quarter;
}
